<app-page-loader></app-page-loader>
<router-outlet />
<ng-container #modals></ng-container>
<ng-container #tooltips></ng-container>
<app-dropdown-teleport></app-dropdown-teleport>
